import clsx from "clsx";
import { FunctionComponent } from "react";

import VergeSubscribeNav from "@voxmedia/duet-ui/components/brand/theverge/VergeSubscribeNav";
import CommentCount, {
  type Props as CommentCountProps,
} from "@voxmedia/duet-ui/components/meta/CommentCount";
import * as globalStyles from "src/config/story-shell-global-styles.css";
import { getSubscribeNavVariant } from "src/utils/subscribe-nav-variant";

interface Props {
  /** When true, subscribe chrome follows theme-contract overrides in GlobalStyles. */
  themeEnabled: boolean;
  commentCountProps?: CommentCountProps | null;
  className?: string;
}

/**
 * Fixed subscribe/sign-in strip over framework MinimalNav. Styling comes from
 * `story-shell-global-styles` token overrides when `themeEnabled`; otherwise
 * from the fixed `verge-franklin` variant.
 */
const SubscribeNavOverlay: FunctionComponent<Props> = ({
  themeEnabled,
  commentCountProps,
  className,
}) => {
  const showCommentCount = Boolean(commentCountProps?.coralId);

  return (
    <div className={clsx(globalStyles.subscribeNavOverlay, className)}>
      <div className={globalStyles.subscribeNavOverlayInner}>
        <VergeSubscribeNav variant={getSubscribeNavVariant(themeEnabled)} />
        {showCommentCount && commentCountProps ? (
          <CommentCount {...commentCountProps} />
        ) : null}
      </div>
    </div>
  );
};

export default SubscribeNavOverlay;
